import { Avatar, ButtonV2 } from '@cimplico/components';
import { useAcceptInvitation } from '../../../../queries/use-accept-invitation';
import { useDeleteInvitation } from '../../../../queries/use-delete-invitation';
import { useInvitations } from '../../../../queries/use-invitations';
import { Invitation } from '../../../../types/invitation';
import { User } from '../../../../types/user';
import { parseTitle } from '../../../../utilities/formatting';

function FirmInvitations(): JSX.Element {
    const invitationQuery = useInvitations();

    if (invitationQuery.isLoading) {
        return <p>Loading...</p>;
    }

    const invitations = invitationQuery.data?.invitations ?? [];

    return (
        <div>
            <p className="text-sm text-contentPrimary font-medium mb-2">Pending invites</p>
            {invitations.length === 0 && <p className="text-sm text-contentSecondary">No pending invites</p>}
            <div className="flex flex-col gap-2">
                {invitations.map((invitation) => {
                    return <InvitationRow key={invitation.id} invitation={invitation} />;
                })}
            </div>
        </div>
    );
}

type InvitationRowProps = {
    invitation: Invitation;
};

function InvitationRow({ invitation }: InvitationRowProps): JSX.Element {
    const declineQuery = useDeleteInvitation();
    const acceptQuery = useAcceptInvitation();

    function decline(): void {
        declineQuery.mutate(invitation.id);
    }

    function accept(): void {
        const shortId = invitation.firm.shortId;

        acceptQuery.mutate(invitation.id, {
            onSuccess: () => {
                window.location.href = `/${shortId}/dashboard`;
            },
        });
    }

    return (
        <div className="p-2 border border-borderPrimary rounded-md">
            <div className="flex items-center gap-2">
                <Avatar size="sm" color="grey" alt={parseTitle(invitation.firm.name)} type="rounded" />
                <p className="font-medium text-contentPrimary shrink-0">{invitation.firm.name}</p>
                <span className="ml-auto">
                    <ButtonV2
                        type="hollow"
                        size="xs"
                        label={'Decline'}
                        onClick={decline}
                        isDisabled={declineQuery.isLoading}
                        isLoading={declineQuery.isLoading}
                    />
                </span>
                <span className="justify-self-end">
                    <ButtonV2
                        type="primary"
                        size="xs"
                        label={'Accept'}
                        onClick={accept}
                        isDisabled={acceptQuery.isLoading}
                        isLoading={acceptQuery.isLoading}
                    />
                </span>
            </div>
        </div>
    );
}

export default FirmInvitations;
